import script from "./tabs-donut-channels.vue?vue&type=script&setup=true&lang=js"
export * from "./tabs-donut-channels.vue?vue&type=script&setup=true&lang=js"

import "./tabs-donut-channels.vue?vue&type=style&index=0&id=49aa1e06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49aa1e06"]])

export default __exports__